/**
 * VistoeraTASK-00577 — what the Canvas page records once the server has answered
 * for a project, kept pure so it is unit-testable.
 *
 *  - OWN (EDITABLE: creator, or the Owner for unattributed legacy rows):
 *    becomes the Canvas Return Context AND the per-user last-opened hint.
 *  - NOT_OWN (READ_ONLY: teammate's team-shared / member project): is only
 *    being VIEWED. It never becomes the return context or the personal recovery
 *    target, and a stale hint / context naming it (older builds) is dropped.
 *    The user's own previous record (project A) is left untouched.
 */
import { setCanvasProjectOwnership, syncCanvasNavigationContextFromProject } from './canvasNavigationContext'
import { clearLastOpenedCanvas, readLastOpenedCanvas, rememberLastOpenedCanvas } from './lastOpenedCanvas'

export type CanvasViewRecordOutcome = 'OWN' | 'NOT_OWN'

export function recordCanvasProjectViewed(args: {
  workspaceId: string
  projectId: string
  userId: string
  readOnly: boolean
}): CanvasViewRecordOutcome {
  const { workspaceId, projectId, userId, readOnly } = args
  if (readOnly) {
    setCanvasProjectOwnership(workspaceId, projectId, false)
    if (readLastOpenedCanvas(userId, workspaceId) === projectId) {
      clearLastOpenedCanvas(userId, workspaceId)
    }
    return 'NOT_OWN'
  }
  setCanvasProjectOwnership(workspaceId, projectId, true)
  syncCanvasNavigationContextFromProject(workspaceId, projectId, 'direct-url')
  rememberLastOpenedCanvas(userId, workspaceId, projectId)
  return 'OWN'
}
